import React from "react";

import { Share, HeadingWIcon } from "@molecules";
import { AppLink } from "@base";
import { Container, Divider, Text, ButtonAlt, Image, Button } from "@atoms";
import loadable from "@loadable/component";

const Sidebar = loadable(() => import("@organisms/Sidebar"));

const WritingPage = ({ data, defaults }) => {
  const { url, hero, content, sidebar } = data;

  return (
    <Container>
      {/* header */}
      <div className="-mx-4 mt-12 flex flex-wrap items-end md:-mx-10 md:mt-24">
        <div className="my-12 w-full px-4 md:px-10">
          <ButtonAlt noIcon={false} to="/resources" reverse>
            Go to All Resources
          </ButtonAlt>
        </div>
        <div className="mt-auto w-full px-4 md:w-2/3 md:px-10">
          <HeadingWIcon {...hero} icon="sunrise" small />
          <Divider className="hidden md:block" />
        </div>
        <div className="w-full px-4 md:w-1/3">
          <div className="font-extended flex items-center">
            <Share url={url} />
          </div>
          <Divider className="hidden md:block" />
        </div>
      </div>
      {/* content */}
      <div className="-mx-4 mb-12 flex flex-wrap md:-mx-10">
        <div className="w-full px-4 pb-12 md:w-2/3 md:px-10">
          {content.image && (
            <div className="my-6">
              <AppLink to={content.websiteUrl || content.download}>
                <Image image={content.image} />
              </AppLink>
            </div>
          )}
          <Text variant="body--large-tight" className="my-6">
            {content.copy}
          </Text>
          <div className="my-6">
            <Button to={content.websiteUrl || content.download}>
              {content.cta}
            </Button>
          </div>
        </div>
        {/* sidebar */}
        {sidebar && (
          <div className="w-full px-6 md:w-1/3">
            <Sidebar hideDivider {...sidebar} defaults={defaults} />
          </div>
        )}
      </div>
    </Container>
  );
};

WritingPage.defaultProps = {};

export default WritingPage;
